import * as libraryEvents from "../services/realTimeNotification/events/libraryEvents";

const getEventAsyncOperations = () => [libraryEvents.ClientUserSessionRegistrationSuccess];

const getAsyncOperations = () => [...getEventAsyncOperations()];

export default getAsyncOperations;
